import { InvoiceStatus } from "@common/types/invoice";
import { NativeInvoiceDetailBase } from "@common/types/nativeInvoice";

export type NativeInvoiceDisplayStatus =
    | "draft"
    | "scheduled"
    | "sent"
    | "open"
    | "overdue"
    | "paid"
    | "void"
    | "uncollectable";

interface Params {
    status: InvoiceStatus;
    due: Date | string | null | undefined;
    nativeDetail?: Pick<
        NativeInvoiceDetailBase,
        "scheduledSendAt" | "sentAt"
    > | null;
}

const STATUS_LABELS: Record<NativeInvoiceDisplayStatus, string> = {
    draft: "Draft",
    scheduled: "Scheduled",
    sent: "Sent",
    open: "Open",
    overdue: "Overdue",
    paid: "Paid",
    void: "Void",
    uncollectable: "Uncollectible",
};

function isPast(value: Date | string | null | undefined): boolean {
    if (!value) {
        return false;
    }
    const time =
        value instanceof Date ? value.getTime() : new Date(value).getTime();
    return Number.isFinite(time) && time < Date.now();
}

export function getNativeInvoiceDisplayStatus({
    status,
    due,
    nativeDetail,
}: Params): NativeInvoiceDisplayStatus {
    if (status === InvoiceStatus.PAID) {
        return "paid";
    }
    if (status === InvoiceStatus.VOID) {
        return "void";
    }
    if (status === InvoiceStatus.UNCOLLECTABLE) {
        return "uncollectable";
    }
    if (status === InvoiceStatus.DRAFT) {
        if (nativeDetail?.scheduledSendAt) {
            return "scheduled";
        }
        return "draft";
    }
    if (status === InvoiceStatus.OPEN) {
        if (isPast(due)) {
            return "overdue";
        }
        if (nativeDetail?.sentAt) {
            return "sent";
        }
        return "open";
    }
    return "draft";
}

export function getNativeInvoiceDisplayStatusLabel(
    status: NativeInvoiceDisplayStatus,
): string {
    return STATUS_LABELS[status];
}
